import { BtnSize, BtnType, Button } from 'components/common/button'
import { Card } from 'components/common/card'
import { Column, Row } from 'components/common/layout'
import { Modal } from 'components/common/modal'
import { BaseText, MediumText } from 'components/common/text'
import { theme } from 'infra/theme'
import React, { useRef } from 'react'
import { FiPlus } from 'react-icons/fi'
import styled from 'styled-components'
import { useOnClickOutside } from 'usehooks-ts'
import { useIsDesktopCSR } from 'utils/hooks'

const MobileFullScreenModal: React.FCC<{ onClose: () => void }> = ({
  onClose,
  children,
}) => {
  return (
    <Modal width={100} onClose={onClose} disableCloseBtn>
      <ModalContent>
        {children}
        <Row style={{ gap: 8 }}>
          <Button
            size={BtnSize.SMALL}
            variant={BtnType.SUPER_LOW}
            onClick={onClose}
            style={{ flex: 1 }}
          >
            닫기
          </Button>

          <Button size={BtnSize.SMALL} onClick={onClose} style={{ flex: 2 }}>
            선택완료
          </Button>
        </Row>
      </ModalContent>
    </Modal>
  )
}

export const DesktopCardMobileModalWrapper: React.FCC<{
  onClose: () => void
  ignoreRef?: React.RefObject<HTMLDivElement>
}> = ({ onClose, ignoreRef, children }) => {
  const cardRef = useRef<HTMLDivElement>(null)
  const isDesktop = useIsDesktopCSR()
  useOnClickOutside(cardRef, (e) => {
    if (ignoreRef?.current?.contains(e.target as Node)) return
    onClose()
  })
  return isDesktop ? (
    <SelectorCard ref={cardRef}>{children}</SelectorCard>
  ) : (
    <MobileFullScreenModal onClose={onClose}>{children}</MobileFullScreenModal>
  )
}

export const AddButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  const isDesktop = useIsDesktopCSR()
  return (
    <Row style={{ gap: 2, cursor: 'pointer' }} onClick={onClick}>
      <FiPlus size={isDesktop ? 16 : 12} color={theme.color.gray1} />
      <AddButtonText>추가하기</AddButtonText>
    </Row>
  )
}

export const Placeholder: React.FCC<{
  value?: '포지션을 추가해주세요' | '스킬을 추가해주세요'
  isDashboard?: boolean
  onClick?: () => void
}> = ({ value, isDashboard, onClick, children }) => {
  return (
    <PlaceholderCard
      isDashboard={isDashboard}
      onClick={onClick}
      isClickable={!!onClick}
    >
      <PlaceholderText>{value || children}</PlaceholderText>
    </PlaceholderCard>
  )
}

export const SelectorCard = styled(Card)`
  padding: 16px;
  border: 1px solid ${(p) => p.theme.color.line};
  @media ${(p) => p.theme.deviceSize.mobile} {
    max-height: 300px;
  }
`

const ModalContent = styled(Column)`
  height: 100%;
  justify-content: space-between;
  padding: 24px;
  gap: 24px;
`

const AddButtonText = styled(MediumText)`
  color: ${(p) => p.theme.color.gray1};
  @media ${(p) => p.theme.deviceSize.desktop} {
    font-size: ${(p) => p.theme.fontSize.desc};
  }
`

const PlaceholderCard = styled(Card)<{
  isDashboard?: boolean
  isClickable?: boolean
}>`
  padding: 20px;
  align-items: center;
  ${(p) => !p.isDashboard && `background-color: ${p.theme.color.background}`};
  ${(p) => p.isClickable && 'cursor: pointer;'}
`

const PlaceholderText = styled(BaseText)`
  color: ${(p) => p.theme.color.gray1};
  @media ${(p) => p.theme.deviceSize.desktop} {
    font-size: ${(p) => p.theme.fontSize.desc};
  }
`
